import { render, staticRenderFns } from "./CityDelete.vue?vue&type=template&id=395f8b64&scoped=true&"
import script from "./CityDelete.vue?vue&type=script&lang=js&"
export * from "./CityDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395f8b64",
  null
  
)

export default component.exports